import { render, staticRenderFns } from "./UploadingFormMobile.vue?vue&type=template&id=0c3a34fb&scoped=true&"
import script from "./UploadingFormMobile.vue?vue&type=script&lang=js&"
export * from "./UploadingFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./UploadingFormMobile.vue?vue&type=style&index=0&id=0c3a34fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a34fb",
  null
  
)

export default component.exports